import { Callout } from '@dev-spendesk/grapes';

import { TokenInput } from 'common/components/TokenInput';
import { useTranslation } from 'common/hooks/useTranslation';

export type FinalizeSetupProps = {
  verificationCode: string[];
  setVerificationCode: (code: string[]) => void;
  hasError?: boolean;
  isDisabled?: boolean;
};

export const FinalizeSetup = ({
  verificationCode,
  setVerificationCode,
  hasError,
  isDisabled,
}: FinalizeSetupProps) => {
  const { t } = useTranslation('global');

  return (
    <div className="flex flex-col gap-16">
      <p className="text-content-primary body-m ms-32">
        {t('profile.authenticationFactors.create.totp.finalizeItemTitle')}
      </p>
      <div className="bg-background-secondary-default rounded-8 flex w-full flex-col items-center justify-center px-40 py-32">
        <TokenInput
          token={verificationCode}
          tokenLength={6}
          onTokenChange={setVerificationCode}
          hasError={hasError}
          isDisabled={isDisabled}
        />
      </div>
      {hasError && (
        <Callout
          title={t(
            'profile.authenticationFactors.create.totp.finalizeItemError',
          )}
          variant="alert"
        />
      )}
    </div>
  );
};
